import { useMixpanelTrackers } from "@jidlomat/terminal-core/hooks/useMixpanelTrackers";
import { useAppSelector } from "@jidlomat/terminal-core/hooks/utilsHooks/storeHooks";
import { selectShortFridgeId } from "@jidlomat/terminal-core/slices/fridgeInfoSlice";
import { logToSentry } from "@jidlomat/terminal-core/utils/logger";
import { BasicModal } from "@jidlomat/terminal-ui/components/global/modals/BasicModal";
import { ModalSupportFooter } from "@jidlomat/terminal-ui/components/global/modals/ModalSupportFooter";
import { ModalContentWrapper } from "@jidlomat/terminal-ui/components/primitives/ModalContentWrapper";
import { ModalTitle } from "@jidlomat/terminal-ui/components/primitives/ModalTitle";
import { Typography, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MaintenanceAnimation } from "./MaintenanceAnimation";

const RemoteRefillModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const theme = useTheme();
	const { trackRemoteRefillModal } = useMixpanelTrackers();

	useEffect(() => {
		logToSentry(`Remote refill modal displayed on fridge: ${fridgeId}`, "info");
		trackRemoteRefillModal("open");

		return () => {
			trackRemoteRefillModal("close");
		};
	}, [fridgeId, trackRemoteRefillModal]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.remoteRefill.title" as never)}</ModalTitle>
			<Typography variant="promoText" sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.remoteRefill.description" as never)}
			</Typography>
			<MaintenanceAnimation />
			<ModalSupportFooter fridgeId={fridgeId} background={theme.palette.copper.main} />
		</ModalContentWrapper>
	);
};

export const RemoteRefillModal = () => (
	<BasicModal modalContent={<RemoteRefillModalContent />} open={true} closable={false} fullHeight={true} />
);
